import { defineComponent, ref, onMounted,onUnmounted  } from './vue.esm-browser.prod.js';


export default defineComponent({
  props: {
    options: { type: Array, required: true },
    selectedOption: { type: Object, required: true },
  },

  // @ts-ignore
  setup(props, { emit }) {  
    /** @typedef {{ dropdownId: string, value: string, text: string[] }} Option */

    const showOptions = ref(false);


    onMounted(() => {      
      document.documentElement.addEventListener('click', handleDocumentClick);
      document.documentElement.addEventListener('close-options', handleCloseOptions);
    });


    onUnmounted(() => {
      document.documentElement.removeEventListener('click', handleDocumentClick);
      document.documentElement.removeEventListener('close-options', handleCloseOptions);
    });


    function handleSelectButtonClick(/** @type {MouseEvent} */ e) {
      showOptions.value = !showOptions.value;
      emit('select-button-click', props.options?.[0]?.id, showOptions.value);
      const customEvent = new CustomEvent('close-options', { detail: { dropdownId: props.selectedOption.dropdownId }});
      document.documentElement.dispatchEvent(customEvent);
    }


    function handleDocumentClick(/** @type {PointerEvent} */e) {
      e.stopPropagation();
      /** @type {HTMLElement | null} */
      // @ts-ignore
      const target = e.target;
      
      if (!target) return;
      const dropdownElements = [...document.querySelectorAll('.Dropdown')];

      if (showOptions.value && dropdownElements && !dropdownElements.some((dropdownEl) => dropdownEl?.contains(target))) {
        showOptions.value = false;
      }
    }

    
    function handleSelectedOptionClick(/** @type {Option} option */ option) {
      emit('select-option-click', option);
      showOptions.value = false;
    }


    function handleCloseOptions(/** @type {CustomEvent<{ dropdownId: any }>} */ e) {
      if (e.detail.dropdownId !== props.options?.[0]?.dropdownId) {
        showOptions.value = false;
      }
    }


    return {
      showOptions,
      handleSelectButtonClick,
      handleSelectedOptionClick,
    };
  },

  template: /* html */`
    <div class="Dropdown">
      <DropdownOption
        v-if="selectedOption"
        :option="selectedOption"
        :isButton="true"
        class="DropdownOption__button"
        @click="handleSelectButtonClick"
      >
        <span v-for="(text, i) in selectedOption.text" :key="i">{{ text }}</span>
        <Chevron class="Dropdown__chevron" />
      </DropdownOption>
      <transition name="dropdown-fade">
        <ul v-if="showOptions && selectedOption" class="Dropdown__options-container">
          <DropdownOption
            v-for="option in options"
            :key="option.value"
            :option="option"
            :isSelected="selectedOption.value === option.value"
            class="DropdownOption__option"
            @dropdown-option-click="handleSelectedOptionClick"
          >
            <span v-for="(text, i) in option.text" :key="i">{{ text }}</span>
          </DropdownOption>
        </ul>
      </transition>
    </div>
  `,
});